<template>
  <div class="article-box">
    <div class="title">
      <a :href="href" target="_blank">#{{ index + 1 }} {{ title }}</a>
      <div>
        <span v-for="item in badge" :key="item">{{ item }}</span>
      </div>
    </div>
    <div class="content">
      <p>
        {{ detail }}
      </p>
    </div>
    <div class="footer">
      <p>Time: {{ time }}</p>
      <p>
        From:
        <a :href="from[1]" target="_blank">{{ from[0] }}</a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Article",
  props: {
    info: Object,
    index: Number,
  },
  setup(props) {
    // title, detail, time, badge, from, href
    return props.info;
  },
};
</script>

<style lang="scss" scoped>
p {
  margin: 0;
}
.article-box {
  position: relative;
  margin: 10px 0px;
  padding-bottom: 5px;
  border-bottom: 1px solid #eee;
}
.title {
  display: flex;
  justify-content: space-between;
}
.title a {
  color: #000;
  font-weight: 900;
  cursor: pointer;
  position: relative;
  text-decoration: none;
  transition: all 0.3s;
}
.title a:hover {
  opacity: 0.8;
  color: #41b883;
}
.title a:after {
  position: absolute;
  content: " ";
  left: 0;
  bottom: -1px;
  width: 0;
  height: 1px;
  transition: all 0.3s;
  background-color: #41b883;
}
.title a:hover:after {
  width: 100%;
}
.title div span {
  display: inline-block;
  min-width: 10px;
  margin: 0px 2px;
  padding: 3px 7px;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  color: #fff;
  text-align: center;
  cursor: default;
  white-space: nowrap;
  vertical-align: middle;
  background-color: #41b883;
  border-radius: 10px;
}

.content {
  padding: 2px 0px;
}

.content p {
  font-size: 14px;
  line-height: 1.5;
  padding: 3px;
}
.footer {
  display: flex;
  justify-content: flex-start;
}
.footer p {
  margin-right: 10px;
  font-size: 14px;
}
.footer p a {
  color: #212529;
}
</style>
